module.exports = __webpack_public_path__ + "assets/icon-previous-light.a04ce33b.svg";